import { useEffect, useState, type MouseEvent } from "react";
import { navLinks } from "@/mocks/movieContent";

export default function SiteNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id: string) => (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    setOpen(false);
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const linkColor = scrolled ? "text-foreground-700 hover:text-primary-600" : "text-background-100 hover:text-background-50";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-gradient-to-b from-foreground-950/60 to-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 flex items-center justify-between">
        <a
          href="#top"
          onClick={go("top")}
          className="flex items-center gap-2.5 group"
        >
          <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-movie-2-line text-lg"></i>
          </span>
          <span
            className={`font-heading text-base md:text-lg font-semibold tracking-wide transition-colors ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            姐姐的朋友电影
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-0.5">
          {navLinks.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={go(item.id)}
              className={`px-3 py-2 text-sm whitespace-nowrap rounded-md transition-colors ${linkColor}`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-2">
          <a
            href="#plot"
            onClick={go("plot")}
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-600"
          >
            开始阅读
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <button
          type="button"
          aria-label="打开导航菜单"
          onClick={() => setOpen((prev) => !prev)}
          className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer transition-colors ${
            scrolled ? "text-foreground-900 hover:bg-background-100" : "text-background-50 hover:bg-background-50/10"
          }`}
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-background-50 border-b border-background-200 max-h-[70vh] overflow-y-auto">
          <nav className="px-4 py-3 grid grid-cols-2 gap-1">
            {navLinks.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={go(item.id)}
                className="px-3 py-2.5 text-sm text-foreground-700 rounded-md cursor-pointer hover:bg-background-100"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}